import { datadogLogs } from '@datadog/browser-logs';

export const initDataDog = () => {
  const clientToken = import.meta.env['VITE_DATADOG_CLIENT_TOKEN'];
  const environment = import.meta.env['VITE_ENV'] || 'development';

  if (!clientToken) {
    console.warn(
      'DataDog configuration is missing. Error tracking will be limited to console only.'
    );
    return;
  }

  try {
    // Initialize with minimal configuration first
    datadogLogs.init({
      clientToken,
      site: 'us5.datadoghq.com',
      service: `dhs-${environment}-client-app`,
      env: environment,
      forwardErrorsToLogs: true,
      sessionSampleRate: 100,
    });
  } catch (error) {
    console.error('Error initializing DataDog:', error);
  }
};
